import { initializeiFrameListener } from 'listeners/iFrameListener';
import { type ZendeskSettings } from 'types/zendeskWidget';
import { type ZopimChatService } from 'v1/services/zopimChatService';

export interface InitializeScriptParams {
  service: ZopimChatService;
  initialSettings?: ZendeskSettings;
  integrationKey: string;
}

const createZendeskScript = (key: string) => {
  const script = document.createElement('script');

  script.setAttribute('id', 'ze-snippet');
  script.setAttribute('referrer', 'no-referrer');
  script.setAttribute(
    'src',
    `https://static.zdassets.com/ekr/snippet.js?key=${key}`,
  );

  return script;
};

export const initializeZendeskScript = ({
  service,
  initialSettings,
  integrationKey,
}: InitializeScriptParams) => {
  const script = createZendeskScript(integrationKey);

  script.onload = () => service.onLoadCallback();

  if (initialSettings) {
    window.zESettings = initialSettings;
  }

  initializeiFrameListener(service);

  document.body.appendChild(script);
};
